export const getNodesCount = (node) => node["@nodes"] && node["@nodes"].filter((n) => n !== "link").length;

export const getLink = (node, nodeName) => {
    const linkNode = nodeName === "link" ? node[nodeName] : node[nodeName].link;
    const label = linkNode && linkNode.label;

    return { linkNode, label };
};
